var APIRequestType;
(function(APIRequestType2) {
  APIRequestType2["SetActiveSlice"] = "setActiveSlice";
  APIRequestType2["SetSliceZoneSize"] = "setSliceZoneSize";
})(APIRequestType || (APIRequestType = {}));
var ClientRequestType;
(function(ClientRequestType2) {
  ClientRequestType2["Ping"] = "ping";
  ClientRequestType2["SetSliceZone"] = "setSliceZone";
  ClientRequestType2["ScrollToSlice"] = "scrollToSlice";
})(ClientRequestType || (ClientRequestType = {}));
export {
  APIRequestType,
  ClientRequestType
};
//# sourceMappingURL=types.js.map
